import { SalesIncentive } from "@omni/types/api/product/bff/shared/salesIncentive.model";
import { CloudSalesIncentive } from "@omni/types/api/product/cloud/shared/salesIncentive.model";
import { AlgoliaSearchSalesIncentive } from "@omni/types/api/search/algolia/product/shared/salesIncentive.model";
import { BffSearchSalesIncentive } from "@omni/types/api/search/bff/product/shared/salesIncentive.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { SalesIncentiveTypeMapper } from "./enums/salesIncentiveType.enumMapper";

const fromBffToAlgoliaSearch: ModelMapper<
    SalesIncentive,
    AlgoliaSearchSalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromBffToAlgoliaSearch(model.type)
    } satisfies AlgoliaSearchSalesIncentive;
};

const fromBffToBffSearch: ModelMapper<
    SalesIncentive,
    BffSearchSalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromBffToBffSearch(model.type)
    } satisfies BffSearchSalesIncentive;
};

const fromCloudToBff: ModelMapper<CloudSalesIncentive, SalesIncentive> = (
    model
) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromCloudToBff(model.type)
    } satisfies SalesIncentive;
};

const fromAlgoliaSearchToBff: ModelMapper<
    AlgoliaSearchSalesIncentive,
    SalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromAlgoliaSearchToBff(model.type)
    } satisfies SalesIncentive;
};

const fromAlgoliaSearchToBffSearch: ModelMapper<
    AlgoliaSearchSalesIncentive,
    BffSearchSalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromAlgoliaSearchToBffSearch(model.type)
    } satisfies BffSearchSalesIncentive;
};

const fromBffSearchToBff: ModelMapper<
    BffSearchSalesIncentive,
    SalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromBffSearchToBff(model.type)
    } satisfies SalesIncentive;
};

const fromBffSearchToAlgoliaSearch: ModelMapper<
    BffSearchSalesIncentive,
    AlgoliaSearchSalesIncentive
> = (model) => {
    return {
        order: model.order,
        type: SalesIncentiveTypeMapper.fromBffSearchToAlgoliaSearch(model.type)
    } satisfies AlgoliaSearchSalesIncentive;
};

export const SalesIncentiveMapper = {
    fromBffToAlgoliaSearch: fromBffToAlgoliaSearch,
    fromBffToBffSearch: fromBffToBffSearch,
    fromCloudToBff: fromCloudToBff,
    fromAlgoliaSearchToBff: fromAlgoliaSearchToBff,
    fromAlgoliaSearchToBffSearch: fromAlgoliaSearchToBffSearch,
    fromBffSearchToBff: fromBffSearchToBff,
    fromBffSearchToAlgoliaSearch: fromBffSearchToAlgoliaSearch
};
